import { Link } from 'react-router-dom';

interface SectionHeadingProps {
  icon: string;
  title: string;
  subtitle?: string;
  moreTo?: string;
  moreLabel?: string;
}

export default function SectionHeading({ icon, title, subtitle, moreTo, moreLabel = '查看更多' }: SectionHeadingProps) {
  return (
    <div className="mb-6 flex items-end justify-between gap-4">
      <div className="flex items-start gap-3">
        <span className="mt-0.5 flex h-9 w-9 shrink-0 items-center justify-center rounded-lg bg-primary-50 text-primary-600">
          <i className={`${icon} text-xl`} />
        </span>
        <div>
          <h2 className="font-heading text-lg font-extrabold text-foreground-950 md:text-2xl">{title}</h2>
          {subtitle && <p className="mt-1 text-xs text-foreground-500 md:text-sm">{subtitle}</p>}
        </div>
      </div>
      {moreTo && (
        <Link
          to={moreTo}
          className="flex shrink-0 items-center gap-1 rounded-md px-3 py-1.5 text-sm font-medium text-primary-600 transition hover:bg-primary-50 whitespace-nowrap"
        >
          {moreLabel}
          <i className="ri-arrow-right-s-line text-lg" />
        </Link>
      )}
    </div>
  );
}